import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Constants, LocalStoragerService, SessionStoragerService,} from '../_utility';
import {Languages, LoggedUser, Role, Roles} from '../_models';
import {jwtDecode} from 'jwt-decode';
import {SpinnerService} from '../_components/spinner/spinner.service';
import {Auth, getAuth, OAuthProvider, signInWithPopup} from "firebase/auth";
import {FirebaseApp, initializeApp} from 'firebase/app';
import {SessionExpiredDialogComponent} from '../_components/session-expired-dialog/session-expired-dialog.component';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public userData: any;
  private auth: Auth;
  private app: FirebaseApp;

  constructor(
    public router: Router,
    private http: HttpClient,
    private spinner: SpinnerService,
    public lStorager: LocalStoragerService,
    private sStorage: SessionStoragerService,
    public dialog: DialogService,
  ) {
    this.app = initializeApp(environment.firebaseConfig);
    this.auth = getAuth();
  }

  // Ritorna true quando utente è loggato e l'email è verifcato
  get isLoggedIn(): boolean {
    return !!this.user && !!this.token;
  }

  // Ritorna il token o stringa vuota
  get token(): string {
    return this.user && this.user.idToken ? this.user.idToken : '';
  }

  // Ritorna se il token è scaduto
  get isExpiredToken(): boolean {
    if (this.token) {
      let tokenDecoded: any = jwtDecode(this.token);
      let expMillis = tokenDecoded.exp * 1000;
      let nowMillis = new Date().getTime();
      return nowMillis > expMillis;
    }

    return false;
  }

  get isMandatoryChangePwd(): boolean {
    let currentUser: LoggedUser | null = this.retrieveCurrentUser();
    if (!currentUser) return false;
    return currentUser ? !currentUser.emailVerified : true;
  }

  // Returns user when is looged or null
  get user(): LoggedUser | null {
    return this.lStorager.getElement(Constants.Storager.CURRENT_USER);
  }

  set user(user: LoggedUser | null) {
    if (user) {
      this.lStorager.setElement(Constants.Storager.CURRENT_USER, user);
    } else {
      this.lStorager.removeElement(Constants.Storager.CURRENT_USER);
    }
  }

  // Ritorna le Roles dell'utente
  get roles(): Roles[] {
    let tmp: LoggedUser | null = this.user;
    return tmp ? tmp.user_roles : [];
  }

  // Ritorna la lingua selezionata
  get lang(): string {
    let retrieved_lang = this.sStorage.getElement(Constants.Storager.LANG);
    return retrieved_lang ? retrieved_lang : Languages.default;
  }

  set lang(lang: string | null) {
    if (lang) {
      this.sStorage.setElement(Constants.Storager.LANG, lang);
    } else {
      this.sStorage.removeElement(Constants.Storager.LANG);
    }
  }

  get displayName(): string | null {
    let currentUser: LoggedUser | null = this.user;
    return currentUser ? currentUser.displayName : null;
  }

  get inizialiNome(): string | null {
    let nameTemp = this.displayName!.toUpperCase().replaceAll("(EXTERNAL)","").trim().split(' ');
    nameTemp.map((n) => n[0]).join('');
    let name = [];
    name.push(nameTemp[0].substring(0, 1));
    name.push(nameTemp[nameTemp.length - 1].substring(0, 1));
    return name.join('');
  }

  SignIn() {
    let provider= new OAuthProvider(environment.firebaseProvider);
    provider.setCustomParameters({
      prompt: 'login',
    });
    return signInWithPopup(this.auth, provider);
  }

  login(token:string) {
    const headers = new HttpHeaders({
      'Authorization':  'Bearer ' + token
    });
    let url = `${environment.host}/login`;
    return this.http.get(url, { headers });
  }

  SignOut() {
    this.lStorager.clearAll();
    this.sStorage.clearAll();
    this.router.navigate(Constants.Routing.LOGIN.routerLink);
  }

  getCurrentUser(): LoggedUser | null {
    let currentUserStr = localStorage.getItem('currentUser');
    if (currentUserStr) {
      return JSON.parse(currentUserStr);
    }
    return null;
  }

  getCurrentUserRoles(): Roles[] {
    let tmp: LoggedUser | null = this.getCurrentUser();
    return tmp ? tmp.user_roles : [];
  }

  public setUserInfo(
    responseLogin: any,
    idToken: string,
  ): LoggedUser | null {
    if (!responseLogin || !idToken) {
      return null;
    }
    let user: LoggedUser = new LoggedUser();
    let tokenDecoded: any = jwtDecode(idToken);
    let roles = responseLogin.roles;
    let str_roles: any[] | string = [];

    user.displayName = tokenDecoded.name ? tokenDecoded.name : null;
    user.idToken = idToken;
    user.email = tokenDecoded.email ? tokenDecoded.email : null;
    user.expiresIn = tokenDecoded.exp ? tokenDecoded.exp : null;
    user.ships = responseLogin.ships ? responseLogin.ships : [];
    user.emailVerified = true;

    if (roles) {
      str_roles = roles;

      if (typeof str_roles === 'string') {
        let tmp: string = str_roles;
        str_roles = [tmp];
      }

      str_roles.forEach((role) => {
        let new_role = Role.get_Role(role);
        if (new_role) roles.push(new_role);
      });

      if (roles) {
        user.user_roles = roles;
      }
    }

    if (user.idToken && user.displayName && user.user_roles) {
      return (this.user = user);
    }

    return null;
  }

  private retrieveCurrentUser(): LoggedUser | null {
    let user: LoggedUser = new LoggedUser();
    let str_user = this.user;

    if (str_user) {
      user = str_user;
    }

    if (user.displayName && user.user_roles) {
      return user;
    }

    return null;
  }

  ShowDialog() {
    this.spinner.hide();
    const ref = this.dialog.open(SessionExpiredDialogComponent, {
      styleClass: 'resizableDialog',
      header: 'Login',
      width: '50vw',
      modal: true,
      closable: false,
    });
    return ref!.onClose;
  }
}
